import BaseTracker from './BaseTracker';



const pinterestEventWhitelist = {
  'PS Completed': {
    name: 'checkout',
    data: { value: 100, order_quantity: 1, currency: 'USD' },
  },
  client_appointment_booked: {
    name: 'lead',
    data: { lead_type: 'Newsletter' },
  },
};

export class PinterestTracker extends BaseTracker {
  constructor(env: string, platform: string) {
    super('Pinterest', 'Tracker (Pinterest)', env, platform);
  }

  /**
    * Performs the actual tracking call.
    * @param {String} eventName The name of the event to track
    * @returns {Promise} Resolves when the event has been logged.
  **/

  async trackEvent(eventName) {
    const anyWindow = window as any;
    if (pinterestEventWhitelist[eventName] && this.env === 'production') {

        const { name, data } = pinterestEventWhitelist[eventName];
        // check if event is on the pinterestEventWhitelist object
        anyWindow?.pintrk?.('track', name, data);
        this.debugLog('trackEvent', eventName);
    }
  }
}
